import { motion } from 'framer-motion';

interface ISlideInEffectProps {
  children: React.ReactNode;
  direction?: 'left' | 'right';
  disableInitialAnimation?: boolean;
  travelDistance?: number;
  transitionType?: 'spring' | 'ease' | 'easeIn' | 'easeOut' | 'easeInOut' | 'just';
  overrideStyles?: React.CSSProperties;
}

export default function SlideInEffect({
  children,
  direction = 'right',
  disableInitialAnimation = false,
  travelDistance = 100,
  transitionType = 'just',
  overrideStyles = {},
}: ISlideInEffectProps) {
  const initialX = direction === 'left' ? -travelDistance : travelDistance;

  return (
    <motion.div
      initial={disableInitialAnimation ? { x: 0, opacity: 1 } : { x: initialX, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: direction === 'left' ? -travelDistance : travelDistance, opacity: 0, transition: { duration: 0.2 } }}
      transition={{
        type: transitionType,
        stiffness: 60,
        damping: 12,
      }}
      style={{
        display: 'flex',
        ...overrideStyles,
      }}
    >
      {children}
    </motion.div>
  );
}
